define('services/progress',[
    'underscore', 'nprogress', 'utils',
], function(_, NProgress, U) {
    // _.extend(NProgress, {
    //     update: function() {
    //
    //     },
    // });
    NProgress.configure({
        // minimum: 0.08,
        // trickle: true, // automatic incrementing behavior
        // trickleSpeed: 200,
        showSpinner: false,
        // parent: 'body',
    });

    return NProgress;
});

